module.exports = __webpack_public_path__ + "static/media/under_construction.f30c2060.png";